'use client';

import React from 'react';

interface NavBarProps {
  onSettings: () => void;
  onHelp: () => void;
}

export function NavBar({ onSettings, onHelp }: NavBarProps) {
  return (
    <div>
      <header className="px-4 py-3 flex items-center justify-between" style={{ backgroundColor: 'rgb(38, 38, 38)' }}>
        <div className="flex items-center gap-3">
          <span className="text-2xl font-bold text-white tracking-tight">Visy</span>
          <span className="text-sm text-white/70 hidden sm:block">Product Photo Identifier</span>
        </div>
        <div className="flex items-center justify-end gap-1">
          <NavIconButton onClick={onSettings} title="Settings" icon={<SettingsIcon />} />
          <NavIconButton onClick={onHelp} title="Help" icon={<HelpIcon />} />
        </div>
      </header>
      <div style={{ height: '4px', backgroundColor: 'rgb(51, 102, 204)' }} />
    </div>
  );
}

function NavIconButton({ onClick, title, icon }: { onClick: () => void; title: string; icon: React.ReactNode }) {
  return (
    <button
      onClick={onClick}
      title={title}
      className="p-2 text-white/70 hover:text-white hover:bg-white/10 rounded transition-colors"
    >
      {icon}
    </button>
  );
}

function SettingsIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  );
}

function HelpIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="10" />
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  );
}
